export const domainMapping = {
  "payswiftly.net": "payswiftly",
  "safepayhub.net": "safepayhub",
  "payglide.net": "payglide",
  "insecurepay.net": "insecurepay",
  "zensupporter.com": "zensupporter",
  "zapaygo.net": "zapaygo",
  "trustassist.net": "trustassist",
  localhost: "localhost",
  default: "SoouPay",
};

export const getBrandName = () => {
  const hostname = window.location.hostname;
  // 提取主域名（假设格式为 [子域名].[主域名].[顶级域名]）
  const parts = hostname.split(".");
  // 取最后两部分（主域名 + 顶级域名）
  const mainDomain = parts.slice(-2).join(".");
  return domainMapping[mainDomain] || domainMapping["default"];
};
